import { EventEmitter, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {NewMessageDto} from '../model/new-message';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  private connection;
  private messageSource = new Subject<string>();
  static atualizarConversa = new EventEmitter<NewMessageDto>();

  constructor() { }

  initConnection() {
    if (this.connection)
      return;

    let current = this;

    abp.signalr.startConnection(abp.appPath + 'signalr-chatHub', function (connection) {
      current.connection = connection;

      connection.on('novaMensagem', function (message) {
        if (abp.session.userId != message.remetenteId) {
          current.changeMessage('novaMensagem', message);
        }
      })
    }).then(function (conncetion) {
      abp.log.debug('Connected to notificationHub server!');
    });
  }

  private changeMessage(message: string, dados:NewMessageDto) {
    ChatService.atualizarConversa.emit(dados);
    this.messageSource.next(message);
  }
}
